var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 92,
    viewBox: "0 0 108 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.0001 9C29.1466 9 9.00009 29.1465 9.00009 54C9.00009 61.164 10.7191 67.9095 13.6936 73.9215L9.17109 92.007C8.14059 96.1245 11.8711 99.8595 15.9931 98.829L34.0786 94.3065C40.0906 97.281 46.8361 99 54.0001 99C78.8536 99 99.0001 78.8535 99.0001 54C99.0001 29.1465 78.8536 9 54.0001 9Z",
    fill: "#F4F5FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4735 62.8785H53.4465C50.4315 62.8785 48.105 60.156 48.6225 57.186C50.1975 48.1275 57.249 47.8125 57.249 42.1875C57.249 40.626 56.979 37.1295 53.217 37.1295C51.183 37.1295 49.986 38.43 49.2885 39.816C48.348 41.6925 46.179 42.615 44.1135 42.2505C40.9815 41.6925 39.06 38.3355 40.3875 35.4465C42.2865 31.32 46.1745 27 53.874 27C66.366 27 68.04 36.783 68.04 41.382C68.04 52.254 59.9445 52.659 58.266 58.923C57.6585 61.182 55.8135 62.8785 53.4735 62.8785ZM59.9625 74.3985C59.9625 76.2525 59.391 77.8185 58.2435 79.092C57.0915 80.361 55.584 81 53.73 81C51.867 81 50.364 80.361 49.2165 79.092C48.069 77.8185 47.4885 76.2525 47.4885 74.3985C47.4885 72.585 48.069 71.0235 49.2165 69.696C50.364 68.3775 51.867 67.7205 53.73 67.7205C55.584 67.7205 57.0915 68.3775 58.2435 69.696C59.391 71.0235 59.9625 72.5895 59.9625 74.3985Z",
    fill: "url(#paint0_linear_343_24653)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_343_24653",
    x1: 54.0007,
    y1: 27,
    x2: 54.0007,
    y2: 81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4671F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.251ff1e3d7244644bb5944453f619b88.svg";
export { ForwardRef as ReactComponent };